import {PropsWithChildren} from 'react';
import {twMerge} from '../../../common/twMerge';

interface Props {
  className?: string;
}

export const DayOfWeekSectionColumnTitle = ({
  children,
  className,
}: PropsWithChildren<Props>) => {
  return (
    <div
      className={twMerge(
        'flex justify-center items-center self-stretch',
        'flex-[1_0_0] py-10pxr rounded-t-8pxr',
        'bg-static-mono-90',
        className
      )}
    >
      <h2
        className={twMerge(
          'flex-[1_0_0]',
          'text-center font-small1-bold',
          'text-static-mono-white'
        )}
      >
        {children}
      </h2>
    </div>
  );
};
